import {
    BreadcrumbsComponent as SourceBreadcrumbsComponent,
} from 'SourceComponent/Breadcrumbs/Breadcrumbs.component';
import React from 'react';
import './Breadcrumbs.override.style';
import history from '@scandipwa/scandipwa/src/util/History';
import { CheckoutStepUrl } from '@scandipwa/scandipwa/src/route/Checkout/Checkout.config';
import { CART_URL } from 'Route/CartPage/CartPage.config';
import ContentWrapper from 'Component/ContentWrapper';

export class BreadcrumbsComponent extends SourceBreadcrumbsComponent {
    render() {
        const { breadcrumbs, areBreadcrumbsVisible } = this.props;
        const {
            location: {
                pathname,
            },
        } = history;

        if (breadcrumbs?.length > 0) {
            if (breadcrumbs[breadcrumbs?.length - 1]?.name !== "") {
                if (!(breadcrumbs[breadcrumbs?.length - 1]?.name !== "Diamond") || !(breadcrumbs[breadcrumbs?.length - 1]?.name !== "Final Ring") || !(breadcrumbs[breadcrumbs?.length - 1]?.name !== "Custmize Pendant") || pathname?.includes("coloreddiamond") || !breadcrumbs[0]?.url && pathname !== "/") {
                    // console.log(breadcrumbs);
                } else {
                    localStorage.removeItem("step");
                    localStorage.removeItem("custmizesku");
                    localStorage.removeItem("diamond");
                    localStorage.removeItem("setting");
                }
            }
        }

        const isHomePage = pathname === "/";
        const isCart = pathname.includes(CART_URL);
        const isCheckout = pathname.includes(CheckoutStepUrl.CHECKOUT_URL);

        if (!areBreadcrumbsVisible || isHomePage || isCart || isCheckout) {
            return null;
        }

        return (
            <ContentWrapper mix={{ block: 'Breadcrumbs' }} label={'Breadcrumbs (current location)...'}>
                <nav aria-label="Breadcrumbs navigation">
                    <ul
                        className="Breadcrumbs-List"
                    >
                        {(
                            breadcrumbs.length
                                ? this.renderBreadcrumbList(breadcrumbs)
                                : this.renderBreadcrumb({}, 0)
                        )}
                    </ul>
                </nav>
            </ContentWrapper>
        );
    }
}

export default BreadcrumbsComponent;
